import * as React from "react"

import { ResponsiveToolCtxProvider } from "@contexts/ResponsiveToolCtx.tsx"
import { AuthCtxProvider } from "@contexts/AuthCtx.tsx"
import { MembershipLayoutCtxProvider } from "@contexts/MembershipLayoutCtx.tsx"
import { SpaceAllPlacesCtxProvider } from "@contexts/SpaceAllPlacesCtx.tsx"
import { BookingsCtxProvider } from "@contexts/BookingsCtx.tsx"

export const AppCtxProvider: React.FC<{
	children: React.ReactNode
}> = ({ children }) => (
	<ResponsiveToolCtxProvider>
		<AuthCtxProvider>
			<MembershipLayoutCtxProvider>
				<SpaceAllPlacesCtxProvider>
					<BookingsCtxProvider>{children}</BookingsCtxProvider>
				</SpaceAllPlacesCtxProvider>
			</MembershipLayoutCtxProvider>
		</AuthCtxProvider>
	</ResponsiveToolCtxProvider>
)
